<div ngClass="filterPanel" ngClass.lt-md="filterPanel filterPanel-sm" fxLayout="column" *ngIf="sourceFacets != null">
  <div class="skip-link-wrapper">
    <a class="skip-link" href="#jumpToResults" (click)="jumpToResults($event)">Jump to results</a>
  </div>
  <div>
    

    <tdms-date-facet></tdms-date-facet>

    <!--Publication facet-->
    <div class="facetSection">
      <div fxLayout="row" fxLayoutAlign="start center">
        <h2 ngClass="facetHeader" ngClass.md="facetHeader-md">Publication title</h2>
      </div>
      <div class="facetViewAll" tabindex="0" role="button" (click)="onViewPubs('pub')" (keyup.enter)="onViewPubs('pub')">
        Select publication title(s)
      </div>
    </div>

    <!--Database type facet-->
    <div class="facetSection" *ngIf="docFacets != null">
      <h2 ngClass="facetHeader" ngClass.md="facetHeader-md">Databases</h2>
      <div class="facetViewAll" tabindex="0" role="button" (click)="onViewPubs('database')" (keyup.enter)="onViewPubs('database')">
        Select database(s)
      </div>
    </div>

    <!--sourceType facet-->
    <fieldset class="facetSection">
      <legend ngClass="facetHeader" ngClass.md="facetHeader-md">Source type</legend>
      <div class="facetContent" fxLayout="column">
        <tdms-wb-checkbox-group
          [options]="sourceFacetSelection"
          class="facetLineItem"
          [selectedValues]="selectedSourceTypeFilterValues"
          (toggle)="onSourceTypeFacetChange($event)"
        ></tdms-wb-checkbox-group>
      </div>
    </fieldset>
    <!-- <div class="bottom">&nbsp;</div> -->

    <!--Document type facet-->
    <fieldset class="facetSection" *ngIf="docFacets != null">
      <legend ngClass="facetHeader" ngClass.md="facetHeader-md">Document type</legend>
      <div class="facetContent">
        <tdms-wb-checkbox-group
          [options]="docFacetSelection"
          [selectedValues]="selectedDocFilterValues"
          (toggle)="onDocFacetChange($event)"
        ></tdms-wb-checkbox-group>
      </div>
    </fieldset>
    
    <div class="bottom">&nbsp;</div>

    <!-- Applied filters -->
    <div class="facetSection" *ngIf="appliedFilters.length > 0">
      <div class="applied-filters-header">
        <h2 ngClass="facetFiltersHeader">Applied filters</h2>
        <p class="facetClearAll" (click)="clearAllFilters()" (keyup.enter)="clearAllFilters()" tabindex="0" role="link">
          Clear all
        </p>
      </div>
      <div [ngClass]="showApplied ? 'af-expand' : 'applied-filters-display'">
        <ul class="applied-filters" #aFilters>
          <li
            class="filter"
            *ngFor="let filter of appliedFilters; index as i"
            (click)="clearFilter(filter)"
            (keyup.enter)="clearFilter(filter)"
            tabindex="0"
            role="button"
          >
            <p class="filter-label" attr.aria-label="remove filter: {{ filter.value }}">{{ filter.value }}</p>
            <i class="bi bi-x"></i>
          </li>
        </ul>
      </div>
      <br />
      <div
        class="facetViewAll"
        tabindex="0"
        *ngIf="isExpandable"
        (click)="showApplied = !showApplied"
        (keyup.enter)="showApplied = !showApplied"
      >
        {{ showApplied ? "View Less" : "View All" }}
      </div>
    </div>

  </div>

  <div class="apply-wrapper" fxLayout="row" fxLayoutAlign="start center">
    <div class="applyButton">
      <button ngClass="apply-button" ngClass.lt-lg="apply-button" (click)="applyFilters()">Apply</button>
    </div>
    <button class="cancelWB" (click)="clearAllFilters()">Clear all</button>
  </div>
</div>
